// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wvz-","left":"styles_left__3qwbD"};